App.module('MessageCenterApp.Requests', function (Requests, App, Backbone, Marionette, $) {
    'use strict';

    var _MESSAGES_LIST_ENDPOINT = MESSAGES_LIST_ENDPOINT,
        _UNREAD_COUNT_MESSAGES_ENDPOINT = UNREAD_COUNT_MESSAGES_ENDPOINT,
        _READ_MESSAGE_ENDPOINT = READ_MESSAGE_ENDPOINT,
        _DELETE_MESSAGE_ENDPOINT = DELETE_MESSAGE_ENDPOINT;

    var messageListRequestDfd = null;

    Requests.getMessagesList = function (limit, offset) {
        if (messageListRequestDfd) {
            return messageListRequestDfd.promise();
        }
        messageListRequestDfd = $.Deferred();

        var endpoint;
        if(!offset) {
            endpoint = !$('#customMsgCenterMessage .messageCenterModalTitle').length ? '/vitality/js/app/_stabs/message_center_empty.json' : '/vitality/js/app/_stabs/message_center_data_short.json';
        } else {
            endpoint = '/vitality/js/app/_stabs/message_center_view_all.json';
        }

        $.ajax({
            url: window.DEBUG_MODE ? endpoint : _MESSAGES_LIST_ENDPOINT,
            type: 'get',
            dataType: 'json'
        })
        .then(this.handleResponse)
        .done(function (data) {
            messageListRequestDfd.resolve(data);
        })
        .fail(function() {
            messageListRequestDfd.reject();
            messageListRequestDfd = null;
        })
        .always(function () {
            messageListRequestDfd = null;
        });

        return messageListRequestDfd.promise();
    };

    Requests.deleteMessage = function (id, type) {
        var deleteMessageRequestDfd = $.Deferred();
        var _separator = _DELETE_MESSAGE_ENDPOINT!==undefined ? (_DELETE_MESSAGE_ENDPOINT.indexOf("?") === -1 ? "?" : "&" ): "?";
        $.ajax({
            url: window.DEBUG_MODE ? 'js/app/_stabs/hero_images_change.json' : _DELETE_MESSAGE_ENDPOINT + _separator + $.param({ id:id,type:type }),
            type: 'post'
        })
        .then(this.handleResponse)
        .done(function (data) {
            deleteMessageRequestDfd.resolve(data);
        })
        .fail(function() {
            deleteMessageRequestDfd.reject();
        })
        .always(function () {
            deleteMessageRequestDfd = null;
        });

        deleteMessageRequestDfd.resolve({'status': 1});
        return deleteMessageRequestDfd.promise();
    };

    Requests.markMessageAsViewed = function (id, type) {
        var requestDfd = $.Deferred();

        $.ajax({
        url: window.DEBUG_MODE ? 'js/app/_stabs/hero_images_change.json' : _READ_MESSAGE_ENDPOINT,
            type: 'post',
            data: { id:id,type:type },
            dataType: 'json'
        })
        .then(this.handleResponse)
        .done(function (data) {
            requestDfd.resolve(data);
        })
        .fail(function() {
            requestDfd.reject();
        })
        .always(function () {
            requestDfd = null;
        });

        requestDfd.resolve({'status': 1});
        return requestDfd.promise();
    };

    Requests.getUnreadMesagesCount = function () {
        var requestDfd = $.Deferred();

        $.ajax({
            url: 1 ? 'js/app/_stabs/hero_images_change.json' : _UNREAD_COUNT_MESSAGES_ENDPOINT,
            type: 'get',
            dataType: 'json'
        })
        .then(this.handleResponse)
        .done(function (data) {
            requestDfd.resolve(data);
        })
        .fail(function() {
            requestDfd.reject();
        })
        .always(function () {
            requestDfd = null;
        });

        requestDfd.resolve({'status': 1});
        return requestDfd.promise();
    };
});
